import styled from 'styled-components'

export const EvixCardRowNo = styled.div`
  font-size: 14px;
  line-height: 1.71;
  color: var(--gray400);
`
